module.exports = __webpack_public_path__ + "static/media/close-white.bbfbeb60.svg";